import { isSectionEnabled, isQuestionEnabled } from './previewHelpers';

/**
 * Determine whether an answer value counts as "empty" (unanswered), across
 * the value shapes used by the various question renderings (text, number,
 * select/radio with "other", checkbox groups, checkbox-with-text, etc).
 */
const isValueEmpty = (value) => {
  if (value === undefined || value === null) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (typeof value === 'number') return Number.isNaN(value);
  if (typeof value === 'boolean') return value === false;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') {
    // select/radio with "other": { value, otherValue }
    if ('value' in value) return isValueEmpty(value.value);
    // checkbox-with-text: { checked, text/otherValue }
    if ('checked' in value) return !value.checked;
    // checkbox group / checkbox-with-select: { [answerId]: true|false|string }
    return !Object.values(value).some(
      (v) => v === true || (typeof v === 'string' && v.trim() !== '')
    );
  }
  return false;
};

/**
 * Walk a form schema and return the labels of required questions that are
 * currently visible (per enableWhen rules) but have no answer in formValues.
 * Returns an empty array when the schema/form is fully valid.
 */
export const getMissingRequiredQuestions = (schema, formValues = {}) => {
  const missing = [];
  if (!schema?.pages) return missing;

  schema.pages.forEach((page) => {
    (page.sections || []).forEach((section) => {
      if (!isSectionEnabled(section, schema, formValues)) return;

      (section.questions || []).forEach((question) => {
        if (!question.required) return;
        if (!isQuestionEnabled(question, formValues, schema)) return;
        if (isValueEmpty(formValues[question.id])) {
          missing.push(question.label || question.id);
        }
      });
    });
  });

  return missing;
};
